import SkapaPill, {
  type PillAttribues as SkapaPillAttribues,
  type PillProps as SkapaPillProps,
} from "@ingka/pill";

export type PillProps = SkapaPillAttribues & SkapaPillProps;

export const Pill = (props: PillProps) => {
  return <SkapaPill prefix="saleslead__" {...props} />;
};
